module.exports = __webpack_public_path__ + "site-build/img/financeIcon.30275913.svg";